import { useEffect, useState } from 'react';
import STMPDetails from './SMTPDetails';
import api from '../../../api/axiosInstance';
import { GeneralSettings } from './Notifications.interfaces';

function Notifications() {
  const [settings, setSettings] = useState<GeneralSettings>();
  useEffect(() => {
    async function getSettingsData() {
      try {
        const response = await api.get('/api/settings');
        setSettings(response.data);
      } catch (error) {
        console.error(error);
      }
    }

    getSettingsData();
  }, [])
  return (
    <>
      {settings !== undefined && 
      <STMPDetails settings={settings} />}
    </>
  );
}

export default Notifications;